import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

/**
 * Reemplaza la autenticación legacy de la librería client-ws-galavail.
 *
 * La librería, antes de cada petición, pide un "user token" propio
 * (GalavailRestAuthService.requestUserToken) y adjunta un header
 * `Authorization: Basic ...`. Ese flujo:
 *  - No funciona en SSR (authServiceUrl se construye vacío en el servidor),
 *    provocando que requestServer() falle y redirija al /404.
 *  - Es innecesario: el backend ya acepta el Bearer token de Auth0 que agrega
 *    el AuthInterceptor (que además sobrescribe el header Authorization).
 *
 * Este stub hace que requestUserToken emita un valor vacío sin tocar la red y
 * devuelva un header Authorization neutro, dejando que el interceptor ponga el
 * Bearer real.
 */
@Injectable()
export class NoOpGalavailRestAuthService {
  requestUserToken(_forceRequest?: boolean): Observable<any> {
    return of('');
  }

  getBasicAuthHeader(): { key: string; value: string } {
    return { key: 'Authorization', value: '' };
  }
}
